import { ParsedUrlQuery } from 'querystring';
import React from 'react';
import { useApolloClient } from '@apollo/client';
import { useLocation, useParams } from 'react-router-dom';
import { ApolloPageLoadEvent } from './events/page-load';
import { recommendationLoad } from './events/recommendation-load';
import { adsLoad } from './events/ads-load';
import { freightEvent } from './events/freight';
import { modalEvent } from './events/modal';
import { experimentExposureEvent } from './events/experiment-exposure';
import { productClick } from './events/product-click';
import { outOfStockLoad } from './events/outofstock-load';
import { dispatchEvent } from './helpers';
import { tiktokViewContent } from './modules/tiktok';

interface WithMetricsProps {
  dispatchMetrics: DispatchMetrics;
}

type DispatchMetrics = (event: string, body: any) => void;

export const withMetrics = <P extends WithMetricsProps>(Component: React.ComponentType<P>) => {
  const Wrapper: React.FC<{ parsedQs: ParsedUrlQuery } & P> = props => {
    const { parsedQs } = props;
    const client = useApolloClient();
    const location = useLocation();
    const params = useParams();

    const dispatchMetrics: DispatchMetrics = (event, body) => {
      const routerProps = {
        parsedQs,
        location,
        params,
      };

      switch (event) {
        case 'page:load':
          ApolloPageLoadEvent({ routerProps, client, body });
          break;
        case 'product:click':
          productClick({ routerProps, client, body });
          break;
        case 'recommendation:load':
          recommendationLoad({ routerProps, client, body });
          break;
        case 'ads:load':
          adsLoad({ routerProps, client, body });
          break;
        case 'freight:event':
          freightEvent({ routerProps, client, body });
          break;
        case 'modal:open':
          modalEvent({ body });
          break;
        case 'outOfStock:load':
          outOfStockLoad({ routerProps, client, body });
          break;
        case 'pickupStore:select':
          dispatchEvent('pickupStore:select', body);
          break;
        /* istanbul ignore next */
        case 'experiment:exposure':
          experimentExposureEvent({ body });
          break;
        case 'tiktok:viewContent':
          tiktokViewContent(body);
          break;
        default:
          dispatchEvent(event, body);
      }
    };

    return <Component {...props} state={undefined} dispatchMetrics={dispatchMetrics} />;
  };

  return Wrapper;
};
